// extracted by mini-css-extract-plugin
module.exports = {"abbr":"Annotation_abbr__1tNaM","tooltip":"Annotation_tooltip__2J2Mb"};